import React from "react";
import Button from '../../components/bronson/Button';
import checkIconSVG from '../../images/icons/check-icon.svg';
import closeIconSVG from '../../images/icons/close-icon.svg';
import withoutVehiclesSvg from '../../images/icons/without-vehicles-icon.svg';
import errorTruckSvg from '../../images/icons/error-truck.svg';
import checkoutIcon from '../../images/icons/checkout-icon.svg';

import '../../css/components/shared/CustomMessage.css';

function CustomMessage({ options }) {

    const printPrimaryButton = () => {
        if (options.primaryButton)
            return (
                <div className="u-mt-large">
                    <Button onClick={options.primaryButton.onClick} replace options={options.primaryButton.options}></Button>
                </div>
            )
        else
            return null;
    }

    const printSecondaryButton = () => {
        if (options.secondaryButton)
            return (
                <div className="u-mt">
                    <Button onClick={options.secondaryButton.onClick} replace options={options.secondaryButton.options}></Button>
                </div>
            )
        else
            return null;
    }

    const printIcon = () => {

        if (options.icon) {
            let icon = null;
            switch (options.icon) {
                case "success":
                    icon = checkIconSVG;
                    break;
                case "error":
                    icon = closeIconSVG;
                    break;
                case "no-vehicles":
                    icon = withoutVehiclesSvg;
                    break;
                case "error-truck":
                    icon = errorTruckSvg;
                    break;
                case "checkout":
                    icon = checkoutIcon;
                    break;
                default:
                    icon = withoutVehiclesSvg;
                    break;
            }
            return <img src={icon}></img>
        } else {
            return null;
        }

    }

    return (
        <div className={"c-custom-message " + (options.small ? "c-custom-message--small" : "")}>
            {printIcon()}
            <p className="u-h6 u-mt-large">{options.title}</p>
            <p className="">{options.body}</p>
            {printPrimaryButton()}
            {printSecondaryButton()}
        </div>
    );
}

export default CustomMessage;
